import { useEffect, useState } from 'react'
import { Button, Col, Container, Form, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroller'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import XLS from 'xlsx'

import { getFullUrl } from '../../../helpers/files'
import { getPrice } from '../../../helpers/getPrice'
import { getCodeByType } from '../../../helpers/productTypes'
import copyIcon from '../../../imgs/copy-icon.png'
import scrollUpIcon from '../../../imgs/up-arrow.png'
import { getAllPackages, updatePackage } from '../../../services/packages'
import { createBatch } from '../../../services/shipping'
import OfficeCountryNavBar from '../OfficeCountryNavBar/OfficeCountryNavBar'

export default function CheckForm() {
  const { loggedUser } = useSelector(state => state.user)
  const { EURToUSD, GBPToUSD } = useSelector(state => state.packages)
  const [packagesList, updatePackagesList] = useState([])
  const [totalWeight, updateTotalWeight] = useState(0)
  const [selectedPackages, setSelectedPackages] = useState([])
  const [nextPageTkn, setNextPageTkn] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [warehouse, setWarehouse] = useState(null)
  const [sendingPackages, setSendingPackages] = useState({})

  useEffect(() => {
    setWarehouse(loggedUser.UserAttributes['custom:warehouse'])

    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getPackagesInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouse])

  const getPackagesInfo = async pageToken => {
    if (warehouse == null) return
    try {
      let filters = {}

      filters = {
        isPaid: true,
        isShipped: true,
        batchName: '',
        warehouse: warehouse,
      }
      if (warehouse == '') delete filters.warehouse

      if (pageToken) {
        filters.nextPage = pageToken
      }
      let packages = await getAllPackages(filters)
      if (packages.nextPage) {
        setNextPageTkn(packages.nextPage)
      } else {
        setNextPageTkn('')
      }

      if (packagesList.length > 0 && nextPageTkn) {
        packages.items = [...packagesList, ...packages.items]
      }
      console.log(packages.items)

      const tWeight = getTotalWeight(packages.items)
      updateTotalWeight(tWeight)
      updatePackagesList(packages.items)
    } catch (error) {
      throw error
    }
  }

  const getNextPage = async () => {
    setIsLoading(true)
    try {
      await getPackagesInfo(nextPageTkn)
    } catch (err) {
      console.log(err)
    }
    setIsLoading(false)
  }

  const getTotalWeight = arr => {
    var totalWeightSum = 0
    for (let f in arr) {
      totalWeightSum = totalWeightSum + arr[f].weight
      //   totalWeightSum=totalWeightSum+parseFloat(arr[f].weight)
    }

    return totalWeightSum
  }

  const onChange = changedPackage => {
    const foundSelectedPackage = selectedPackages.find(selectedPackage => selectedPackage.id === changedPackage.id)
    if (foundSelectedPackage) {
      const newPackagesIds = selectedPackages.filter(selectedPackage => selectedPackage.id !== foundSelectedPackage.id)
      setSelectedPackages(newPackagesIds)
    } else {
      setSelectedPackages(prevState => [...prevState, changedPackage])
    }
  }

  const submitbatch = async (currSelectedPackages = selectedPackages) => {
    if (!currSelectedPackages.length) return
    let batchName = window.prompt('Choose Name For the Batch')
    if (!batchName) return

    // Set loading state for selected packages
    const loadingState = {}
    currSelectedPackages.forEach(pkg => {
      loadingState[pkg.id] = true
    })
    setSendingPackages(loadingState)

    try {
      await createBatch({ batchName, packages: currSelectedPackages })

      // Export to Excel
      var workbook = XLS.utils.table_to_book(document.querySelector('.tableForPackagePage'))
      XLS.writeFile(workbook, 'packages.xlsx')
      // Remove the batched packages from the UI
      const updatedPackagesList = packagesList.filter(pkg => !currSelectedPackages.some(selectedPkg => selectedPkg.id === pkg.id))
      createCustomsExcel(updatedPackagesList)
      updatePackagesList(updatedPackagesList) // Update the state
    } catch (error) {
      console.log(error)
      alert(`Error! ${error.response?.data?.msg || error.message} \n ${error.response?.data?.error || ''}`)
    } finally {
      // Clear loading state for all packages
      setSendingPackages({})
      setSelectedPackages([]) // Clear the selected packages
    }
  }

  const postman = async pId => {
    const p = packagesList.find(p => p.id === pId)
    const receipt_url = getFullUrl(p.buyingReciptKey)

    const str = `
      {
      "barcode": "${p.trackingNumberToIsrael}",
      "orderID": "${p.id}",
      "invoiceID": "${p.id}",
      "receiptURL":"${receipt_url}",
      "sender":
           {
            "name": "SHIPTANBUL",
            "addrLine1": "ferhatpasa mah. maresal fevzi cakmak",
            "city": "Istanbul",
            "country": "TR",
            "contactName": "Shiptanbul Office",
            "phoneNumber": "972525227852"
           },
      "receiver":
           {
                 "name": "${p.costumer_firstName} ${p.costumer_LastName}",
                 "addrLine1": "${p.shippingAdress_adress} ",
                 "addrLine2": "${p.shippingAdress_apartmentNumber}",
                 "city": "${p.shippingAdress_city}",
                 "country": "IL",
                 "zip": "${p.shippingAdress_postalCode}",
                 "contactName": "${p.costumer_firstName} ${p.costumer_LastName}",
                 "phoneNumber":"${0 + p.unit}"
      }, "items":
           {
                 "description": "${getContents()}",
                 "declaredValue": "${getPrice(p, EURToUSD, GBPToUSD)}",
                 "currency": "USD",
                 "weight":"${p.weight}"
           },
      "weight": "${p.weight}",
      "volumetricWeight": "${(p.height * p.length * p.width) / 5000}",
      "serviceLine":"${p.shippingMethod}"
      }
    `

    function getContents() {
      let str = ''
      p.contents.forEach(obj => (str += `${obj.quantity} X ${obj.productCategory}`))
      return str
    }

    try {
      navigator.clipboard.writeText(str)
      document.getElementById(`postman-btn ${p.id}`).innerText = ':)'
    } catch (err) {
      console.log(err)
    }

    console.log(str)
  }

  const onSelectAll = ({ target }) => {
    if (target.checked) {
      setSelectedPackages(packagesList)
    } else {
      setSelectedPackages([])
    }
  }

  const createCustomsExcel = (pkgs = packagesList) => {
    if (warehouse == 'USA') {
      let data = []
      pkgs.forEach(p => {
        data.push({
          'Order No./Invoice No.': p.trackingNumberToIsrael,
          'HAWB No.': '',
          'Mother Box': p.motherBox,
          'Recipient name': `${p.costumer_LastName} ${p.costumer_firstName}`,
          'Recipient address': `${p.shippingAdress_adress} ${p.shippingAdress_apartmentNumber}, ${p.shippingAdress_city} ${p.shippingAdress_postalCode} `,
          'Content description': p.contents[0].productCategory,
          'Customs tariff code': getCodeByType(p.contents[0].productCategory),
          'Number [pcs]': p.contents[0].quantity,
          'Value [$]': p.valueInUSD,
          'Price [$]': p.valueInUSD,
        })
      })

      //add position in the start of the object
      data = data.map((obj, idx) => {
        return { position: idx + 1, ...obj }
      })

      const workSheet = XLS.utils.json_to_sheet(data)
      const workBook = XLS.utils.book_new()
      XLS.utils.book_append_sheet(workBook, workSheet, 'packages')
      XLS.writeFile(workBook, 'shiptanbul-packages.xlsx')
    } else {
      let data = []
      pkgs.forEach(p => {
        //calculate ahead the quantity of the items in the whole package
        let packageContentsQuantity = p.contents.reduce((acc, content) => {
          acc += content.quantity
          return acc
        }, 0)

        for (let index = 0; index < p.contents.length; index++) {
          data.push({
            'Order No./Invoice No.': p.trackingNumberToIsrael,
            'HAWB No.': '',
            'Mother Box': p.motherBox,
            'Recipient name': `${p.costumer_LastName} ${p.costumer_firstName}`,
            'Recipient address': `${p.shippingAdress_adress} ${p.shippingAdress_apartmentNumber}, ${p.shippingAdress_city} ${p.shippingAdress_postalCode} `,
            'Content description': p.contents[index].productCategory,
            'Customs tariff code': getCodeByType(p.contents[index].productCategory),
            'Number [pcs]': p.contents[index].quantity,
            'Value [$]': Math.round((p.valueInUSD / packageContentsQuantity) * 100) / 100,
            'Price [$]': Math.round((p.valueInUSD / packageContentsQuantity) * p.contents[index].quantity * 100) / 100,
          })
        }
      })

      //add position in the start of the object
      data = data.map((obj, idx) => {
        return { position: idx + 1, ...obj }
      })

      const workSheet = XLS.utils.json_to_sheet(data)
      const workBook = XLS.utils.book_new()
      XLS.utils.book_append_sheet(workBook, workSheet, 'packages')
      XLS.writeFile(workBook, 'shiptanbul-packages.xlsx')
    }
  }

  const onClickAssignMotherBox = async () => {
    if (!selectedPackages.length) return
    const motherBoxName = prompt('Choose name for the box')
    if (!motherBoxName) return

    let statePackages = [...packagesList]
    try {
      for (let i = 0; i < selectedPackages.length; i++) {
        await updatePackage(selectedPackages[i].id, {
          motherBox: motherBoxName,
        })

        //update the state packages
        statePackages = statePackages.map(p => {
          if (p.id === selectedPackages[i].id) {
            p.motherBox = motherBoxName
          }
          return p
        })
      }
    } catch (error) {
      console.log(error)
      alert(`Error! ${error.response.data?.msg}`)
    } finally {
      updatePackagesList(statePackages)
    }

    alert(`Assigned successfully to mother box "${motherBoxName}"`)
    setSelectedPackages([])
  }

  return (
    <div style={{ marginTop: '100px' }}>
      {loggedUser.permissions['Admin'] && <OfficeCountryNavBar warehouse={warehouse} setWarehouse={setWarehouse} anp={false} />}

      <Row>
        <Col style={{ textAlign: 'center' }}>
          <h4> Packages Check-list for shipping </h4>
        </Col>
      </Row>

      <Row style={{ marginLeft: '8%', alignItems: 'center' }}>
        <Button onClick={() => submitbatch()} disabled={!selectedPackages.length}>
          {'Create Batch'}
        </Button>

        <Button onClick={() => createCustomsExcel()}> Create Customs Excel</Button>

        <Button onClick={() => onClickAssignMotherBox()} disabled={!selectedPackages.length}>
          Assign to mother box
        </Button>
      </Row>

      <div className='motherbox-btn-cont'>
        <Button onClick={() => onClickAssignMotherBox()} disabled={!selectedPackages.length}>
          Assign to <br /> mother box
        </Button>
      </div>

      <Container style={{ marginTop: '1%', maxWidth: '1480px' }}>
        <InfiniteScroll
          loadMore={() => {
            if (!isLoading && nextPageTkn) {
              getNextPage(nextPageTkn)
            }
          }}
          threshold={120}
          hasMore={nextPageTkn && !isLoading}
        >
          <Table className='tableForPackagePage'>
            <thead>
              <tr>
                <th>
                  {' '}
                  Check All <br />
                  <input
                    type='checkbox'
                    checked={selectedPackages.length && selectedPackages.length === packagesList.length}
                    id='checkbox-master'
                    onClick={onSelectAll}
                  />
                </th>
                <th>Index</th>
                <th> Costumer Full Name</th>
                <th> Package ID</th>
                <th> Mother Box</th>
                <th> XLT number</th>
                <th> Weight</th>
                <th> Products</th>
                <th> Location</th>
                <th> Warehouse</th>
                <th> XLT sticker</th>
                <th> Postman</th>
                <th> Shipping method</th>
                <th> Volumetric weight</th>
              </tr>
            </thead>
            <tbody>
              {packagesList.map((o, i) => {
                const isPackageSending = sendingPackages[o.id] // Check if the package is sending
                return (
                  <tr key={i}>
                    <td>
                      {' '}
                      <Form.Check
                        onChange={() => onChange(o)}
                        inline
                        name={o.id}
                        checked={!!selectedPackages.find(selectedPackage => selectedPackage.id === o.id)}
                        type='checkbox'
                        disabled={isPackageSending} // Disable checkbox if the package is sending
                      />{' '}
                    </td>
                    <td>{isPackageSending ? <Spinner animation='border' size='sm' role='status' /> : i + 1}</td>
                    <td> {o.costumer_firstName + ' ' + o.costumer_LastName}</td>
                    <td> {o.id}</td>
                    <td> {o.motherBox}</td>
                    <td> {o.trackingNumberToIsrael}</td>
                    <td> {o.weight}</td>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {o?.contents?.map((c, i) => {
                            return (
                              <span key={i}>
                                {i > 0 && ', '}
                                {c.productCategory} X {c.quantity}
                              </span>
                            )
                          })}
                        </Tooltip>
                      }
                    >
                      <td style={{ textAlign: 'center' }}>{o.contents?.reduce((t, v) => t + parseInt(v.quantity), 0) || '-'}</td>
                    </OverlayTrigger>

                    <td>{o.warehouseLocation}</td>
                    <td>{o.warehouse}</td>
                    <td>
                      <Link
                        to={`/office-sticker/${o.trackingNumberToIsrael}/${o.costumer_firstName + ' ' + o.costumer_LastName}/${
                          o.unit
                        }/${o.brand}/${
                          o.shippingAdress_adress +
                          ' ' +
                          o.shippingAdress_apartmentNumber +
                          ' ' +
                          o.shippingAdress_city +
                          ' ' +
                          o.shippingAdress_postalCode
                        }`}
                        target='_blank'
                      >
                        <div>Get sticker</div>
                      </Link>
                    </td>
                    <td>
                      <div id={`postman-btn ${o.id}`} onClick={() => postman(o.id)} style={{ cursor: 'pointer' }}>
                        <img src={copyIcon} width='20px' className='copy-icon' />
                      </div>
                    </td>
                    <td>{o.shippingMethod}</td>
                    <td>{(Number(o.height ?? 1) * Number(o.width ?? 1) * Number(o.length ?? 1)) / 5000}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>

          {isLoading && (
            <div style={{ textAlign: 'center', margin: '20px' }}>
              <Spinner animation='border' role='status'></Spinner>
            </div>
          )}
          {!nextPageTkn && !isLoading && <div style={{ textAlign: 'center', margin: '20px' }}>No more packages to load.</div>}
        </InfiniteScroll>
        <div className='weight-floating'>{'Total Weight: ' + totalWeight}</div>
        <Row>
          {/* <Col>
                <Button variant="danger" onClick={() => submitAllBtnHandler()}>
                  {" "}
                  All in one batch{" "}
                </Button>
              </Col> */}
        </Row>
        <img
          src={scrollUpIcon}
          className='scroll-up-btn'
          onClick={() => {
            window.scrollTo(0, 0)
          }}
        />
      </Container>
    </div>
  )
}

//removed on turkey update:
// const submitAllBtnHandler = async () => {
//   setSelectedPackages([])
//   submitbatch(packagesList)
// }
// const comparePackageWeight = (packageA, packageB) => {
//   if (packageA.weight < packageB.weight) {
//     return -1
//   }
//   if (packageA.weight > packageB.weight) {
//     return 1
//   }
//   return 0
// }

// const saveExcel = (companyPriority) => {
//   const rows = [
//     [
//       'TS Sıra No',
//       'Kargo Manifesto No',
//       'Taşıma Senedi No',
//       'Sıra No',
//       'Gönderen',
//       'Gönderen Ünvan',
//       'Gönderen VN',
//       'Alıcı Ünvan',
//       'Alıcı Adres',
//       'Sevk Ülkesi',
//       'Ülke Adı',
//       'Ticaret Ülke',
//       'Ülke Adı',
//       'Çıkış Ülkesi',
//       'Ülke Adı',
//       'Menşe Ülke',
//       'Ülke Adı',
//       'Gideceği Ülke',
//       'Ülke Adı',
//       'Teslim Şekli',
//       'Teslim Yeri',
//       'Kap Adedi',
//       'Kap Cinsi',
//       'Ticari Tanım',
//       'GTip',
//       'Brut KG',
//       'Net KG',
//       'Rejim',
//       'Tamamlayıcı Ölçü',
//       'Tamamlayıcı Ölçü Miktarı',
//       'Fat. Doviz',
//       'Fatura',
//       'Fatura No',
//       'Fatura Tarihi',
//     ],
//   ]

//   const company = exportCompanies.find((comp) => comp.priority === companyPriority)

//   exportedPackages.info[companyPriority].forEach((p) => {
//     const price = p.price
//     if (p.contents?.length) {
//       p.contents.forEach((c) => {
//         rows.push([
//           '',
//           '',
//           p.trackingNumberToIsrael && p.trackingNumberToIsrael.substr(6, p.trackingNumberToIsrael.length),
//           '1',
//           '2385',
//           company.fullName,
//           '7691920820',
//           `${p.costumer_firstName} ${p.costumer_LastName}`,
//           `${p.shippingAdress_adress} ${p.shippingAdress_apartmentNumber}, ${p.shippingAdress_city}, Israel`,
//           '052',
//           'TÜRKİYE',
//           '624',
//           'İSRAİL',
//           '052',
//           'TÜRKİYE',
//           '052',
//           'TÜRKİYE',
//           '624',
//           'İSRAİL',
//           'DDP',
//           'İSRAİL',
//           '',
//           'Bl',
//           c.productCategory,
//           getCodeByType(c.productCategory),
//           (p.weight / p.contents.length).toFixed(2),
//           (p.weight / p.contents.length - 0.01).toFixed(2),
//           '1000',
//           'AD',
//           c.quantity,
//           'TL',
//           (price / p.contents.length).toFixed(2),
//           p.id.substr(p.id.length - 12),
//           '',
//         ])
//       })
//     }
//   })
//   const workSheet = XLS.utils.aoa_to_sheet(rows)

//   //auto fit columns with
//   workSheet['!cols'] = fitToColumnWith(rows)

//   const workBook = XLS.utils.book_new()
//   XLS.utils.book_append_sheet(workBook, workSheet, 'cxGridExport')
//   XLS.writeFile(workBook, 'cxGridExport.xlsx')
// }

// const printInvoice = (p) => {
//   // in order to export the invoice div as pdf it needs to be visible in scroll. so we need to change to scroll to capture it
//   setIsInvoiceVisable(p)
//   const currentScroll = document.documentElement.scrollTop
//   window.scrollTo(0, 0)
//   setTimeout(() => {
//     // printDocument(p.id, p.costumer_firstName + " " + p.costumer_LastName);
//     const el = document.getElementById(p.id)
//     const opt = {
//       filename: p.costumer_firstName + ' ' + p.costumer_LastName,
//     }
//     html2pdf(el, opt)

//     setIsInvoiceVisable(null)
//     window.scrollTo(0, currentScroll)
//   }, 1)
// }

//   const sortByCompany = () => {
//   const MAX_TOTAL_WEIGHT = 100000000

//   const sortedExportCompanies = [...exportCompanies]
//   // .sort(
//   //   (exportCompanyA, exportCompanyB) =>
//   //     exportCompanyA.priority - exportCompanyB.priority
//   // );

//   const packages = sortedExportCompanies.reduce(
//     (acc, _, i) => {
//       acc.info[i] = []
//       acc.ids[i] = []

//       return acc
//     },
//     {
//       info: {},
//       ids: {},
//     }
//   )

//   let currentCompany = '0'
//   let totalWeightExportedPackages = 0
//   let index = 0

//   const packagesSortedByWeight = [...packagesList]
//   // .sort(comparePackageWeight);

//   while (true) {
//     if (!packagesSortedByWeight?.length) break

//     packages.info[currentCompany].push(packagesSortedByWeight[index])

//     packages.ids[currentCompany].push(packagesSortedByWeight[index].id)

//     totalWeightExportedPackages += packagesSortedByWeight[index].weight

//     index++

//     // no more packages
//     if (!packagesSortedByWeight[index]) {
//       break
//     }

//     const hasNextCompany = !!packages.ids[+currentCompany + 1]

//     // move to the next company
//     if (hasNextCompany && totalWeightExportedPackages + packagesSortedByWeight[index].weight > MAX_TOTAL_WEIGHT) {
//       totalWeightExportedPackages = 0
//       currentCompany = (+currentCompany + 1).toString()
//     }
//   }

//   setExportedPackages(packages)
// }

// const getExportCompanyByPackageId = (packageId) => {
//   let companyIdx = 0
//   let currCompanyIdx = 0
//   while (!companyIdx) {
//     const isFoundCompany = exportedPackages.ids[currCompanyIdx].includes(packageId)

//     if (isFoundCompany) {
//       companyIdx = currCompanyIdx
//       break
//     } else {
//       if (currCompanyIdx < exportCompanies.length) {
//         currCompanyIdx++
//       } else {
//         console.error(`exportCompany index ${currCompanyIdx} was not found!`)
//         break
//       }
//     }
//   }

//   return exportCompanies.find((comp) => comp.priority === companyIdx)
// }

//   const handleExportCompaniesPriorityChange = ({ target }, shortName) => {
//   const newExportCompanies = exportCompanies.map((comp) => {
//     if (comp.shortName === shortName) {
//       comp.priority = +target.value
//     }
//     return comp
//   })

//   setExportCompanies(newExportCompanies)
// }

// //xlsx utility to auto fit column width
// function fitToColumnWith(arrayOfArray) {
//   // get maximum character of each column
//   return arrayOfArray[0].map((a, i) => ({
//     wch: Math.max(...arrayOfArray.map((a2) => a2[i]?.toString().length)),
//   }))
// }
